<template>
    <div id="chatWindow">
        <VideoCallScreen :participants="participants" v-if="videoCallMode" />
        <div :class="{ opened: isOpen, closed: !isOpen }" class="sc-chat-window">
            <Header
                :colors="colors"
                :imageUrl="titleImageUrl"
                :participants="participants"
                :ticket-mode="ticketMode"
                :title="title"
                :headerTitle="this.headerTitle"
                @change-to-ticket="handleTicket"
                @deleteKVKK="() => (alertType = 'deleteKVKK')"
                @closeChat="() => (alertType = 'closeChat')"
            >
                <template>
                    <slot name="header"></slot>
                </template>
            </Header>
            <div v-if="pageIndex === 3 && alertType === null">
                <ChatHistoryListTwo
                    :colors="colors"
                    :message-styling="messageStyling"
                    :vuescrollOptions="vuescrollOptions"
                />
            </div>
            <div v-else-if="pageIndex === 4 && alertType === null">
                <SelectLanguage />
            </div>
            <div v-else-if="alertType">
                <CacharelAlert
                    v-if="CONFIG.IS_CACHAREL(visitingPage)"
                    :iconName="alertType === 'deleteKVKK' ? 'DeleteBaloon' : 'SocketCouple'"
                    :text="
                        alertType === 'deleteKVKK'
                            ? this.$t('visitorLanguage.deleteConversation')
                            : this.$t('visitorLanguage.endTheConversation')
                    "
                    style="color: var(--form-color-text)"
                    @ok="() => alertOkClickHandler()"
                    @cancel="() => (alertType = null)"
                />

                <PierreCardinAlert
                    v-else-if="CONFIG.IS_PIERRECARDIN(visitingPage)"
                    :iconName="alertType === 'deleteKVKK' ? 'DeleteBaloon' : 'SocketCouple'"
                    :text="
                        alertType === 'deleteKVKK'
                            ? this.$t('visitorLanguage.deleteConversation')
                            : this.$t('visitorLanguage.endTheConversation')
                    "
                    style="color: var(--form-color-text)"
                    @ok="() => alertOkClickHandler()"
                    @cancel="() => (alertType = null)"
                />
                <UspaPoloAlert
                    v-else-if="CONFIG.IS_USPOLO(visitingPage)"
                    :iconName="alertType === 'deleteKVKK' ? 'DeleteBaloon' : 'SocketCouple'"
                    :text="
                        alertType === 'deleteKVKK'
                            ? this.$t('visitorLanguage.deleteConversation')
                            : this.$t('visitorLanguage.endTheConversation')
                    "
                    style="color: var(--form-color-text)"
                    @ok="() => alertOkClickHandler()"
                    @cancel="() => (alertType = null)"
                />

                <Alert
                    v-else
                    :iconName="alertType === 'deleteKVKK' ? 'DeleteBaloon' : 'SocketCouple'"
                    :text="
                        alertType === 'deleteKVKK'
                            ? this.$t('visitorLanguage.deleteConversation')
                            : this.$t('visitorLanguage.endTheConversation')
                    "
                    style="color: var(--form-color-text)"
                    @ok="() => alertOkClickHandler()"
                    @cancel="() => (alertType = null)"
                />
            </div>
            <div v-else-if="showAfterActions && !reconnecting">
                <CacharelFeedBack
                    v-if="pageIndex === 5 && CONFIG.IS_CACHAREL(visitingPage)"
                    :agent="title"
                    :participants="participants"
                />
                <PierreCardinFeedBack
                    v-else-if="pageIndex === 5 && CONFIG.IS_PIERRECARDIN(visitingPage)"
                    :agent="title"
                    :participants="participants"
                />
                <UspaFeedBack
                    v-else-if="pageIndex === 5 && CONFIG.IS_USPOLO(visitingPage)"
                    :agent="title"
                    :participants="participants"
                />
                <FeedBack
                    v-else-if="pageIndex === 5"
                    :agent="title"
                    :participants="participants"
                    :settings="settings"
                />

                <CacherelFeedBackResult v-if="pageIndex === 6 && CONFIG.IS_CACHAREL(visitingPage)" />
                <PierreCardinFeedBackResult v-else-if="pageIndex === 6 && CONFIG.IS_PIERRECARDIN(visitingPage)" />
                <UspaFeedBackResult v-else-if="pageIndex === 6 && CONFIG.IS_USPOLO(visitingPage)" />
                <FeedBackResult v-else-if="pageIndex === 6" />
            </div>
            <div v-else>
                <div v-if="previewMode && pageIndex === 1">
                    <MessageList
                        :alwaysScrollToBottom="true"
                        :colors="colors"
                        :messageStyling="messageStyling"
                        :messages="messages"
                        :participants="[{ _id: 1, name: 'John Doe' }]"
                        :showTypingIndicator="showTypingIndicator"
                        @remove="$emit('remove', $event)"
                        @scrollToTop="$emit('scrollToTop')"
                        :conversation-terminated="!connected"
                    >
                        <template v-slot:user-avatar="scopedProps">
                            <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
                        </template>
                        <template v-slot:text-message-body="scopedProps">
                            <slot
                                :me="scopedProps.me"
                                :message="scopedProps.message"
                                :messageColors="scopedProps.messageColors"
                                :messageText="scopedProps.messageText"
                                name="text-message-body"
                            >
                            </slot>
                        </template>
                        <template v-slot:system-message-body="scopedProps">
                            <slot :message="scopedProps.message" name="system-message-body"></slot>
                        </template>
                        <template v-slot:text-message-toolbox="scopedProps">
                            <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox">
                            </slot>
                        </template>
                    </MessageList>
                    <UserInput
                        v-show="!ticketMode"
                        :colors="colors"
                        :onSubmit="() => {}"
                        :placeholder="placeholder"
                        :sendTyping="sendTyping"
                        :showEmoji="showEmoji"
                        :showFile="showFile"
                        @edit="$emit('edit', $event)"
                    />
                </div>
                <div v-else>
                    <div v-if="connectingSocket" id="connectingAlert">
                        <span>{{ $t("message.connecting") }}</span>
                    </div>
                    <div v-if="reconnecting" id="reconnectionAlert">
                        <span>{{ $t("message.reconnecting") }}</span>
                    </div>
                    <div
                        v-show="settingsFetched"
                        id="messageContent"
                        ref="messagesContent"
                        class="messages-content"
                        :style="{
                            background: `linear-gradient(0deg,${backgroundColorFirst},${backgroundColorSecond})`,
                            color: 'white',
                        }"
                    >
                        <div v-if="!connected && !showAfterActions">
                            <OfflineSupportRequestForm
                                v-if="offlineMode || pageIndex === 2"
                                :ticket-mode="ticketMode"
                                @change-to-ticket="handleTicket"
                                @updateTitle="updateTitle"
                            />
                            <div v-else>
                                <LoginForm v-if="loginFormRequired" @change-to-ticket="handleTicket" />
                            </div>
                        </div>
                        <div class="information-content">
<!--                            <div v-if="connected && loadMore" class="d-flex justify-content-center">-->
<!--                                <md-progress-spinner-->
<!--                                    v-observe-visibility="loadIt"-->
<!--                                    md-mode="indeterminate"-->
<!--                                    style="color: var(&#45;&#45;color7)"-->
<!--                                    class="loadMoreSpinner"-->
<!--                                />-->
<!--                            </div>-->
                            <div v-if="!loadedBefore && connected" class="d-flex justify-content-center">
                                <md-button @click="getChatHistory" style="text-transform: capitalize">
                                    {{ $t("message.chatHistory") }}
                                </md-button>
                            </div>
                            <MessageList
                                v-if="connected || showAfterActions || (!loginFormRequired && !offlineMode)"
                                :alwaysScrollToBottom="alwaysScrollToBottom && !pauseScroll"
                                :colors="colors"
                                :messageStyling="messageStyling"
                                :messages="oldMessages.concat(messages)"
                                :onSubmit="onUserInputSubmit"
                                :participants="participants"
                                :scrollVS="$refs['vs']"
                                :showTypingIndicator="showTypingIndicator"
                                @remove="$emit('remove', $event)"
                                @mounted="() => scrollButtonClickHandler()"
                                :conversation-terminated="!connected"
                            >
                                <template v-slot:user-avatar="scopedProps">
                                    <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar">
                                    </slot>
                                </template>
                                <template v-slot:text-message-body="scopedProps">
                                    <slot
                                        :me="scopedProps.me"
                                        :message="scopedProps.message"
                                        :messageColors="scopedProps.messageColors"
                                        :messageText="scopedProps.messageText"
                                        name="text-message-body"
                                    >
                                    </slot>
                                </template>
                                <template v-slot:system-message-body="scopedProps">
                                    <slot :message="scopedProps.message" name="system-message-body"></slot>
                                </template>
                                <template v-slot:text-message-toolbox="scopedProps">
                                    <slot
                                        :me="scopedProps.me"
                                        :message="scopedProps.message"
                                        name="text-message-toolbox"
                                    >
                                    </slot>
                                </template>
                            </MessageList>
                            <div
                                class="scroll-button"
                                :style="{ bottom: isRepTyping ? '100px' : '70px' }"
                                v-if="isExistNewMessage && !offlineMode && connected"
                            >
                                <div class="scroll-button-container">
                                    <EllipsIconButton
                                        iconName="ArrowB"
                                        bgColor="var(--primary_)"
                                        @btnClicked="() => scrollButtonClickHandler()"
                                        padding="18px"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <TypingMessage v-show="isRepTyping" :messageColors="{}" />

                    <div v-if="pageIndex !== 2 && !showAfterActions">
                        <UserInput
                            v-if="isUserInputVisible()"
                            :colors="colors"
                            :onSubmit="onUserInputSubmit"
                            :placeholder="placeholder"
                            :sendTyping="sendTyping"
                            :showEmoji="showEmoji"
                            :showFile="showFile"
                            @edit="$emit('edit', $event)"
                            :chatbot-active="chatbotActive"
                            @pressEnter="scrollButtonClickHandler"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "./../popup-chat/Header.vue";
import MessageList from "./MessageList.vue";
import UserInput from "./UserInput.vue";
import UserList from "./UserList.vue";
import LoginForm from "../LoginForm";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import AfterActions from "../AfterActions";
import { log2 } from "../../../utils/log2";
import * as _ from "lodash";
import Rate2 from "../Rate2";
import { sendTranscript } from "../../../api/chat";
import OfflineSupportRequestForm from "../OfflineSupportRequestForm";
import { sessionId } from "../../../utils/session";
import version from "../../../utils/version";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { bufferTime, filter } from "rxjs/operators";
import beep from "../../../assets/media/new_message.ogg";
import TypingMessage from "./messages/TypingMessage";
import VideoCallScreen from "../VideoCallScreen.vue";
import ChatHistoryList from "../ChatHistoryList";
import ChatHistoryListTwo from "../ChatHistoryListTwo.vue";
import { chatBaloonIsOpened, sendCommandToParentWindow } from "../../../utils/parentWindowConnection";
import { deletePersonalData, fetchChatHistory } from "../../../api/visitor";
import request from "../../../utils/request";
import DateUtils from "../../../utils/DateUtil";
import SelectLanguage from "../SelectLanguage.vue";
import Alert from "../Alert.vue";
import PierreCardinAlert from "../uspaV2/PierreCardinAlert.vue";
import CacharelAlert from "../uspaV2/CacharelAlert.vue";
import { publishMessage, SystemMessageTypes } from "../../../utils/systemPubSub";
import FeedBack from "../FeedBack.vue";
import UspaFeedBack from "../uspaV2/UspaFeedBack.vue";
import FeedBackResult from "../FeedBackResult.vue";
import UspaPoloAlert from "../uspaV2/UspaPoloAlert.vue";
import CacherelFeedBackResult from "../uspaV2/CacherelFeedBackResult.vue";
import PierreCardinFeedBackResult from "../uspaV2/PierreCardinFeedBackResult.vue";
import EllipsIconButton from "../../../common/IconButton.vue";
import PierreCardinFeedBack from "../uspaV2/PierreCardinFeedBack.vue";
import CacharelFeedBack from "../uspaV2/CacharelFeedBack.vue";
import UspaFeedBackResult from "../uspaV2/UspaFeedBackResult.vue";
import { CONFIG } from "../../../utils/config";

const log = log2("ChatWindow");

export default {
    components: {
        ChatHistoryList,
        FeedBack,
        PierreCardinFeedBack,
        FeedBackResult,
        PierreCardinFeedBackResult,
        ChatHistoryListTwo,
        VideoCallScreen,
        Header,
        MessageList,
        UserInput,
        UserList,
        LoginForm,
        OfflineSupportRequestForm,
        AfterActions,
        Rate2,
        TypingMessage,
        SelectLanguage,
        Alert,
        PierreCardinAlert,
        CacharelAlert,
        UspaPoloAlert,
        EllipsIconButton,
        CacherelFeedBackResult,
        CacharelFeedBack,
        UspaFeedBack,
        UspaFeedBackResult,
    },
    props: {
        sendTyping: {
            type: Function,
            default: () => {},
        },
        showEmoji: {
            type: Boolean,
            default: false,
        },
        showCloseButton: {
            type: Boolean,
            default: true,
        },
        showFile: {
            type: Boolean,
            default: false,
        },
        participants: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            required: true,
        },
        titleImageUrl: {
            type: String,
            default: "",
        },
        onUserInputSubmit: {
            type: Function,
            required: true,
        },
        onClose: {
            type: Function,
            required: true,
        },
        messageList: {
            type: Array,
            default: () => [],
        },
        isOpen: {
            type: Boolean,
            default: () => false,
        },
        placeholder: {
            type: String,
            default: "Write a message...",
        },
        showTypingIndicator: {
            type: String,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
        chatbotActive: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            // visibilityUspa: CONFIG.VISITOR_SPECIAL_UI.visibilityUspa,
            headerColorFirst: "#EC4B1D",
            headerColorSecond: "#EC4B1D",
            backgroundColorFirst: "#FFFFFF",
            backgroundColorSecond: "#FFFFFF",
            loading: false,
            transcriptIsSent: false,
            isRepTyping: false,
            repTypingTracker: undefined,
            repTypingEndTracker: undefined,
            isExistNewMessage: false,
            scrollPosition: null,
            vuescrollOptions: {
                vuescroll: {
                    mode: "native",
                    sizeStrategy: "percent",
                    detectResize: true,
                },
                scrollPanel: {
                    initialScrollY: false,
                    initialScrollX: false,
                    scrollingX: false,
                    scrollingY: true,
                    speed: 300,
                    easing: undefined,
                    verticalNativeBarPos: "right",
                },
                rail: {
                    size: "7px",
                    background: "#fff",
                    opacity: 0.3,
                },
                bar: {
                    size: "7px",
                    background: "#fff",
                    opacity: 0.6,
                },
            },
            beep: Audio,
            ticketMode: false,
            updateLanguage: false,
            alertType: null,
            page: 1,
            loadMore: false,
            pauseScroll: true,
            loadedBefore: false,
            oldMessages: [],
            headerTitle: "",
            scrollButton: false,
            CONFIG,
        };
    },
    computed: {
        ...mapState({
            visitingPage: (state) => state.app.visitingPage,
            pageIndex: (state) => state.app.pageIndex,
            settings: (state) => state.setting.settings,
            connected: (state) => state.chat.connected,
            site: (state) => state.site.site,
            showAfterActions: (state) => state.app.showAfterActions,
            visitorId: (state) => state.chat.visitorId,
            chatAgents: (state) => state.chat.chatAgents,
            conversationId: (state) => state.chat.lastConversationId,
            mobileVersion: (state) => state.app.mobileVersion,
            offlineMode: (state) => state.setting.offlineMode,
            volume: (state) => state.app.volume,
            videoCallMode: (state) => state.app.videoCallMode,
            previewMode: (state) => state.app.previewMode,
            settingsFetched: (state) => state.setting.fetched,
            loginFormRequired: (state) => {
                const loginFormRequired = state.setting.settings.loginFormRequired;
                const customLoginFormEnabled = state.setting.settings.customLoginFormEnabled;
                const customLoginFormIsValid = !!state.customLoginForm.inputs.filter((x) => x.visible).length;
                if (customLoginFormEnabled && !customLoginFormIsValid) {
                    return false;
                } else {
                    return loginFormRequired;
                }
            },
            connectionLost: (state) => state.chat.connectionLost,
            visitorInteracted: (state) => state.app.visitorInteracted,
        }),
        ...mapGetters({
            reconnecting: "chat/reconnecting",
            connectingSocket: "chat/connectingSocket",
            settings: "setting/getSetting",
        }),
        messages() {
            let messages = this.messageList;
            if (!this.loginFormRequired && !this.ticketMode) {
                return [...messages];
            }
            return messages;
        },
        isAnyUserConnected() {
            return !this.chatAgents.some((x) => x._id === "chatbot");
        },
    },
    methods: {
        ...mapActions({
            toggleCloseChatConfirmation: "app/toggleCloseChatConfirmation",
            toggleAfterActions: "app/toggleAfterActions",
            disconnectChat: "chat/disconnect",
            resetConversation: "chat/resetConversation",
            toggleRating: "app/toggleRating",
            setVisitorIsLoggedIn: "chat/setVisitorIsLoggedIn",
            setVisitorIsLogging: "chat/setVisitorIsLogging",
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        getColors() {
            const colors = this.settings.chatCustomizationSettings.versionV2Theme.colors;
            this.backgroundColorFirst = colors.backgroundColorFirst;
            this.backgroundColorSecond = colors.backgroundColorSecond;
            //document.documentElement.style.setProperty("--demoBackgroundForBefore", colors.backgroundColorFirst);
        },
        isUserInputVisible() {
            const isConnected = this.connected && !this.reconnecting;
            if (this.ticketMode) return false;
            else {
                return isConnected || (!this.loginFormRequired && !this.offlineMode);
            }
        },
        listenMessageContentScroll() {
            this.$refs.messagesContent.addEventListener("scroll", (e) => {
                //console.log("abc refs", {h:e.target.scrollHeight, t: e.target.scrollTop, o:e.target.offsetHeight})
                if (e.target.scrollTop + 20 > e.target.scrollHeight - e.target.offsetHeight) {
                    this.isExistNewMessage = false;
                }
            });
        },
        scrollButtonClickHandler() {
            this.isExistNewMessage = false;
            setTimeout(() => {
                if (this.$refs.messagesContent) {
                    this.$refs.messagesContent.scrollTop = this.$refs.messagesContent.scrollHeight;
                }
            }, 100);
        },
        alertOkClickHandler() {
            if (this.alertType === "closeChat") {
                this.changePageIndex(5);
                this.onClose();
                this.alertType = null;
            }
            if (this.site && this.visitorId && this.alertType === "deleteKVKK") {
                deletePersonalData(this.site._id, this.visitorId).then((isDeleted) => {
                    if (isDeleted.status == 200) {
                        this.alertType = null;
                        publishMessage(SystemMessageTypes.PERSONAL_DATA_DELETED, {});
                    }
                });
            }
        },
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: this.visitorId,
                conversationId: this.conversationId,
                siteId: this.site._id,
                sessionId,
                version,
            });
        },
        reconnect() {
            this.toggleRating(false);
            this.toggleAfterActions(false);
            this.resetConversation();
            this.setVisitorIsLoggedIn(false);
            this.setVisitorIsLogging(false);
            this.connect();
            this.transcriptIsSent = false;
        },
        startSendTranscript() {
            log("startSendTranscript başladı");
            this.loading = true;
            sendTranscript(this.conversationId)
                .then((x) => {
                    this.transcriptIsSent = true;
                    (this.loading = false), log("respons başarılı");
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
        },
        handleTicket(val) {
            this.ticketMode = val;
            log("event is here ", { val });
        },
        loadIt: _.debounce(function (e) {
            if (e && this.loadMore) {
                this.getChatHistory();
            }
        }, 500),
        getChatHistory() {
            fetchChatHistory(this.site._id, this.visitorId, this.page, 1)
                .then((res) => {
                    log("fetchChatHistory", res.data);
                    const { conversations, totalCount, currentPage, pageSize } = res.data;
                    if (!!conversations.length)
                        this.loadHistoryMessages(
                            conversations[0]._id,
                            DateUtils.formatDateTime(conversations[0].createdDate, this.$i18n.locale),
                        );
                    this.loadMore = totalCount > currentPage;
                })
                .finally(() => {
                    this.page++;
                    this.loadedBefore = true;
                });
        },
        loadHistoryMessages(chatId, date) {
            const convertMessages = (items) => {
                const allMessages = items
                    .map((x, i) => {
                        let type = "";
                        let author = "";
                        if (x.messageType === "system") {
                            type = "system";
                        } else if (["user", "chatbot"].includes(x.messageType)) {
                            type = "text";
                            author = x.userId || "chatbot";
                        } else if (x.messageType === "private") {
                            type = "private";
                        } else if (x.messageType === "visitor") {
                            type = "text";
                            author = "me";
                        } else if (x.messageType === "user-media" || x.messageType === "visitor-media") {
                            author = x.messageType === "user-media" ? x.userId : "me";
                            if (x.asset.mime.includes("image")) {
                                type = "image";
                            } else if (x.asset.mime.includes("audio")) {
                                type = "audio";
                            } else {
                                type = "asset";
                            }
                        }
                        return {
                            type,
                            author,
                            data: {
                                text: x.message || x.description,
                                textTranslated: x.translatedMessage,
                                meta: DateUtils.formatHour(x.createdDate),
                            },
                            raw: x,
                        };
                    })
                    .filter((x) => x !== undefined);
                allMessages.push({
                    author: "",
                    type: "divider",
                    date,
                    raw: { _id: null },
                });
                log("allMessages", allMessages);
                return allMessages;
            };
            if (chatId) {
                return request({
                    url: `/conversations/${chatId}/messages`,
                    method: "get",
                }).then((response) => {
                    let items = response.data.data;
                    items = _.orderBy(
                        _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                        (q) => new Date(q.createdDate).getTime(),
                        "asc"
                    );
                    let unReadElement = document.getElementById(
                        "sc-message_" + _.get(this.oldMessages, "[0].raw._id", 0)
                    );
                    this.oldMessages = convertMessages(items).concat(this.oldMessages);
                    this.pauseScroll = true;
                    if (!!unReadElement) unReadElement.scrollIntoView();
                });
            }
        },
        updateTitle(newTitle) {
            this.headerTitle = newTitle;
        },
    },
    async created() {
        log("ChatWindow created");
    },
    mounted() {
        const setElementHeight = () => {
            if (window.outerWidth < 950) {
                const selectLangElement = document.getElementById("messageContent");
                if (selectLangElement) {
                    selectLangElement.style.height = "92%";
                } else {
                    console.warn("Element with ID 'selectLang' not found.");
                }
            }
        };
        setElementHeight();
        window.addEventListener("resize", setElementHeight);
        log("mounted", { connecting: this.connecting, reconnecting: this.reconnecting });
        chatBaloonIsOpened(() => {
            this.scrollButtonClickHandler();
        });
        this.listenMessageContentScroll();
        this.beep = new Audio(beep);

        socketMessageStream.pipe(filter((x) => x.cmd === "message" && x.data.messageType === "user")).subscribe(() => {
            this.beep.volume = this.volume / 100;
            if (this.visitorInteracted) {
                this.beep.play();
            }
            sendCommandToParentWindow("badge");
        });
        this.repTypingTracker = socketMessageStream.subscribe(
            ({ cmd, data }) => {
                if (cmd === "message") {
                    const type = data.type || data.messageType || "";
                    log("repTypingTracker", { cmd, data, type });
                    if (type === "rep-typing") {
                        this.isRepTyping = true;
                        if (this.repTypingEndTrackerTimerId) clearTimeout(this.repTypingEndTrackerTimerId);
                        this.repTypingEndTrackerTimerId = setTimeout(() => {
                            if (this.isRepTyping) this.isRepTyping = false;
                        }, 2000);
                    } else if (type === "user-message" || type.includes("chatbot")) {
                        this.isRepTyping = false;
                    }
                }
            },
            (err) => {
                log.error("repTypingTracker error", err);
            }
        );

        this.repTypingEndTracker = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "message" && x.data.type === "rep-typing"),
                bufferTime(2000),
                filter((xs) => xs.length === 0)
            )
            .subscribe(
                (x) => {
                    this.isRepTyping = false;
                },
                (error) => {
                    console.error("sub error", error);
                }
            );
        this.getColors();
    },
    updated() {
        log("updated", {
            connecting: this.connecting,
            reconnecting: this.reconnecting,
            afterAction: this.showAfterActions,
        });
    },
    beforeDestroy() {
        this.repTypingTracker.unsubscribe();
        this.repTypingEndTracker.unsubscribe();
        if (this.repTypingEndTrackerTimerId) clearTimeout(this.repTypingEndTrackerTimerId);
        window.removeEventListener("resize", this.setElementHeight);
    },
    watch: {
        windowWidth(newWidth) {
            this.setElementHeight();
        },
        connected(nVal, oVal) {
            if (nVal === false && nVal !== oVal) {
                this.loadedBefore = false;
                this.loadMore = false;
                this.page = 1;
                this.oldMessages = [];
                if (this.alertType === "closeChat") {
                    /*In case the connection is terminated, the customer representative voting screen opens.*/
                    this.changePageIndex(5);
                    this.onClose();
                    this.alertType = null;
                }
            }
        },
        alertType() {
            if (this.alertType) {
                this.updateLanguage = false;
            }
        },
        pageIndex() {},
        showAfterActions() {
            if (this.showAfterActions && !this.reconnecting && this.pageIndex != 5) {
                this.changePageIndex(5);
            }
        },
        messageList: {
            handler: function (next, prev) {
                const lastMessage = this.messageList.slice(-1)[0];
                if (lastMessage && this.$refs.messagesContent) {
                    const { scrollHeight, scrollTop, clientHeight } = this.$refs.messagesContent;
                    if (!this.isExistNewMessage && scrollHeight - scrollTop - clientHeight >= 150) {
                        if (lastMessage.author !== "me") {
                            this.isExistNewMessage = true;
                        }
                    }
                    if (!this.isExistNewMessage && scrollHeight - scrollTop - clientHeight < 150) {
                        this.isExistNewMessage = false;
                        setTimeout(() => {
                            this.$refs.messagesContent.scrollTop = this.$refs.messagesContent.scrollHeight;
                        }, 1);
                    }
                }
            },
            immediate: true,
        },
        settings() {
            this.getColors();
        },
    },
};
</script>

<style lang="scss" scoped>
#chatWindow {
    position: relative;
    height: 100vh;
    background: var(--header-color-second) !important;
}

.sc-chat-window {
    width: 100%;
    height: calc(100vh - 40px);
    box-sizing: border-box;
    background: transparent;
    color: var(--header-text-color) !important;
    display: flex;
    flex-direction: column;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    animation: fadeIn;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    position: relative;
    border: 3px solid var(--header-color-second);
    border-radius: 23px !important;
}

.messages-content {
    padding-bottom: 30px !important;
}

.sc-chat-window.closed {
    opacity: 0;
    display: none;
    bottom: 90px;
}

.scroll-button {
    position: fixed;
    bottom: 70px;
    left: 15px;
}

@keyframes fadeIn {
    0% {
        display: none;
        opacity: 0;
    }

    100% {
        display: flex;
        opacity: 1;
    }
}

.sc-message--me {
    text-align: right;
}

.sc-message--them {
    text-align: left;
}

@media (max-width: 450px) {
    .sc-chat-window {
        width: 100%;
        height: 100%;
        max-height: 100%;
        right: 0px;
        bottom: 0px;
        border-radius: 0px;
    }

    .sc-chat-window {
        transition: 0.1s ease-in-out;
    }

    .sc-chat-window.closed {
        bottom: 0px;
    }
}

#reconnectionAlert {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(232, 79, 79);
    padding: 29px 22px;
    color: white;
    font-weight: 500;
    font-size: 14px;
    position: absolute;
    top: 70px;
    z-index: 9;

    span {
        margin: 0 auto;
    }
}

#connectingAlert {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2396f3;
    padding: 29px 22px;
    color: white;
    font-weight: 500;
    font-size: 14px;
    position: absolute;
    top: 70px;
    left: 0;
    z-index: 9;

    span {
        margin: 0 auto;
    }
}
</style>
<style lang="scss">
.loadMoreSpinner {
    .md-progress-spinner-circle {
        stroke: var(--color7) !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/ChatWindow.vue